export enum EducationType {
    HotWorker = 1,
    PermitIssuer = 2,
    HotWorkerInstructorPartOne = 3,
    HotWorkerInstructorPartTwo = 4,
    PermitIssuerInstructor = 5,
    PedagogyForInstructor = 6
}
